<template>
  <div class="branded">
    <slot />
  </div>
</template>

<script>
import { useBrandingStore } from "~/stores/branding";
import tinycolor from "tinycolor2";

function calculateDarken(color) {
  return (
    "#" +
    tinycolor
      .mix(
        tinycolor(
          "rgb " +
            Math.floor(
              (tinycolor(color).toRgb().r * tinycolor(color).toRgb().r) / 255
            ) +
            " " +
            Math.floor(
              (tinycolor(color).toRgb().g * tinycolor(color).toRgb().g) / 255
            ) +
            " " +
            Math.floor(
              (tinycolor(color).toRgb().b * tinycolor(color).toRgb().b) / 255
            )
        ),
        color,
        25
      )
      .toHex()
  );
}

function calculateLighten(color, amount) {
  return "#" + tinycolor.mix(tinycolor("#ffffff"), color, amount).toHex();
}

const store = useBrandingStore();

export default {
  data() {
    return {
      brandPrimary: store.brandPrimary,
      brandPrimaryLight: calculateLighten(store.brandPrimary, 10),
      brandPrimaryDark: calculateDarken(store.brandPrimary),
      brandSecondary: store.brandSecondary,
      brandSecondaryLight: calculateLighten(store.brandSecondary, 10),
      brandSecondaryDark: calculateDarken(store.brandSecondary),
      textBlack: store.black,
      gray600: calculateLighten(store.black, 74),
      gray400: calculateLighten(store.black, 36),
      gray300: store.gray300,
      gray200: calculateLighten(store.black, 12),
      gray100: store.gray100,
      gray50: calculateLighten(store.black, 4),
      logoBigUrl: store.logoBigUrl,
      systemError: store.systemError,
      systemErrorDark: calculateDarken(store.systemError),
      systemWarning: store.systemWarning,
      systemWarningDark: calculateDarken(store.systemWarning),
      systemSuccess: store.systemSuccess,
      systemSuccessLight: calculateLighten(store.systemSuccess, 20),
      systemSuccessDark: calculateDarken(store.systemSuccess),
      systemErrorLight: calculateLighten(store.systemError, 20),
    };
  },
};
</script>

<style>
.branded {
  --brandPrimary: v-bind(brandPrimary);
  --brandPrimaryLight: v-bind(brandPrimaryLight);
  --brandPrimaryDark: v-bind(brandPrimaryDark);
  --brandSecondary: v-bind(brandSecondary);
  --brandSecondaryLight: v-bind(brandSecondaryLight);
  --brandSecondaryDark: v-bind(brandSecondaryDark);
  --black: v-bind(textBlack);
  --gray600: v-bind(gray600);
  --gray400: v-bind(gray400);
  --gray300: v-bind(gray300);
  --gray200: v-bind(gray200);
  --gray100: v-bind(gray100);
  --gray50: v-bind(gray50);
  --systemError: v-bind(systemError);
  --systemErrorLight: v-bind(systemErrorLight);
  --systemErrorDark: v-bind(systemErrorDark);
  --systemWarning: v-bind(systemWarning);
  --systemWarningDark: v-bind(systemWarningDark);
  --systemSuccess: v-bind(systemSuccess);
  --systemSuccessLight: v-bind(systemSuccessLight);

}
.branded {
  display: flex;
  flex-grow: 1;
}

.branded * {
  /* visibility: initial; */
}
</style>
